import MutationTypes from '../../MutationTypes';
export default {
    showLoading: async ({ commit }) => {
        commit(MutationTypes.SET_IS_LOADING, true);
    },
    hideLoading: async ({ commit }) => {
        //window.clearInterval(setInterval);
        commit(MutationTypes.SET_IS_LOADING, false);
    },
    alert: async ({ commit }, param) => {
        commit(MutationTypes.SET_IS_ALERT, param);
    }
};
